<settings-page-layout>
  <div class="container">
    @if (!showSkeleton) {
      <div class="container-content">
        <div class="header">
          <div class="header__left">
            <pdq-button (onClick)="backToIntegrations()" variant="light" icon="side_left_arrow"></pdq-button>
            @if (logoUrl) {
              <img [src]="logoUrl" />
            }
            <p class="title">{{ integrationType?.displayName }}</p>
          </div>
          <div class="header__right">
            @if (!isApiKeyIntegration()) {
              <pdq-button
                [loading]="connectionLoading"
                [variant]="integration?.isConnected ? 'light' : 'primary'"
                [label]="integration?.isConnected ? 'Disconnect' : 'Connect'"
                (onClick)="!integration?.isConnected ? handleConnect() : handleDisconnect()"></pdq-button>
            }
          </div>
        </div>
        <pdq-card color="white" variant="popover">
          <div class="content">
            <pdq-tabs-group variant="underline" (onChange)="onTabChange($event)">
              @for (tab of tabs; track tab) {
                <pdq-tab [value]="tab.value" [label]="tab.label" [active]="tab.active"></pdq-tab>
              }
            </pdq-tabs-group>
            <div class="tab-container">
              @switch (currentTab) {
                @case (Tab.ALL_RECIPES) {
                  <all-recipes
                    [integrationType]="integrationType"
                    [recipes]="integration?.recipes"
                    (onTryTemplateClick)="onTabChange(Tab.RECIPE_TEMPLATES)"></all-recipes>
                }
                @case (Tab.RECIPE_TEMPLATES) {
                  <recipe-templates
                    [integrationType]="integrationType"
                    [recipeTemplates]="integrationType?.recipeTemplates"></recipe-templates>
                }
                @case (Tab.OVERVIEW) {
                  <integration-details-overview [integrationType]="integrationType"></integration-details-overview>
                }
                @case (Tab.SETTINGS) {
                  <integration-platform-specific-components
                    [integrationType]="integrationType"
                    [integration]="integration"></integration-platform-specific-components>
                }
                @case (Tab.METRICS) {
                  <triple-whale-metrics
                    [integrationType]="integrationType"
                    [integration]="integration"></triple-whale-metrics>
                }
              }
            </div></div
        ></pdq-card>
      </div>
    } @else {
      <div>
        <div class="header">
          <div class="header__left">
            <skeleton-thumbnail size="small"></skeleton-thumbnail>
          </div>
          <div class="header__right"><skeleton-display-text></skeleton-display-text></div>
        </div>
        <div class="content">
          <skeleton-tabs></skeleton-tabs>
          <div class="tab-container" style="display: flex; flex-direction: column; gap: 8px">
            <skeleton-body-text></skeleton-body-text>
            <skeleton-body-text></skeleton-body-text>
            <skeleton-body-text></skeleton-body-text>
          </div>
        </div>
      </div>
    }
    <ng-template #skeleton>
      <div>
        <div class="header">
          <div class="header__left">
            <skeleton-thumbnail size="small"></skeleton-thumbnail>
          </div>
          <div class="header__right"><skeleton-display-text></skeleton-display-text></div>
        </div>
        <div class="content">
          <skeleton-tabs></skeleton-tabs>
          <div class="tab-container" style="display: flex; flex-direction: column; gap: 8px">
            <skeleton-body-text></skeleton-body-text>
            <skeleton-body-text></skeleton-body-text>
            <skeleton-body-text></skeleton-body-text>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</settings-page-layout>
